export default {
    // 格式化14位数字日期 如：20210322212121 -> 2021-03-22 21:21:21
    timeFormat (val) {
      const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
      return val.replace(pattern, '$1-$2-$3 $4:$5:$6')
    }
  }